import {ProcessFlowchartValidationError} from 'processes/graph-builder-processes/validation/ProcessFlowchartForValidationTypes';
import {SaveState} from 'ui-library/SaveStatusIndicator';

/**
 * Determines the save state based on whether a save is in flight and whether there are blocking errors.
 */
export function calculateSaveState({
  isSaveInFlight,
  isDirty,
  validationErrors,
  lastSaveError,
  isInitialMount = false,
}: {
  isSaveInFlight: boolean;
  isDirty: boolean;
  validationErrors: Array<ProcessFlowchartValidationError>;
  lastSaveError?: Error | null;
  isInitialMount?: boolean;
}): {saveState: SaveState | null; customSaveStatusMessage?: string} {
  if (isInitialMount) {
    return {saveState: null, customSaveStatusMessage: undefined};
  }

  if (isSaveInFlight) {
    return {saveState: SaveState.SAVING};
  }

  if (lastSaveError != null) {
    return {saveState: SaveState.FAILED};
  }

  const blockingErrors = validationErrors.filter((error) => error.blocksPersistence);
  if (blockingErrors.length > 0) {
    return {saveState: SaveState.UNSAVED, customSaveStatusMessage: 'Resolve errors to save changes'};
  }

  if (isDirty) {
    return {saveState: SaveState.SAVING};
  }

  return {saveState: SaveState.SAVED};
}
